import { createAction, createClearAction } from 'redux/redux-actions';
import {
  CLEAR_CONFIRM_MESSAGE,
  CLEAR_HEADER_TITLE,
  CLEAR_HELP_CONTENT,
  CLEAR_ORDER_CART,
  CLEAR_SEARCH_CONTENT,
  CLEAR_SIDEBAR_ITEMS,
  CLEAR_SIDEBAR_OPEN,
  CLEAR_FILTER_CATEGORY,
  SET_CONFIRM_ACTION,
  SET_CONFIRM_MESSAGE,
  SET_HEADER_TITLE,
  SET_HELP_CONTENT,
  SET_HOT_NOTIFICATION,
  SET_LOCALE,
  SET_ORDER_CART,
  SET_PAGINATION,
  SET_PRINT_CONTENT,
  SET_SCROLL_TOP,
  SET_SEARCH_CONTENT,
  SET_SIDEBAR_ITEMS,
  SET_SIDEBAR_OPEN,
  SET_FILTER_CATEGORY,
} from 'redux/constants';

export const clearSidebarItems = createClearAction(CLEAR_SIDEBAR_ITEMS);
export const setSidebarItems = createAction(SET_SIDEBAR_ITEMS);

export const clearSidebarOpen = createClearAction(CLEAR_SIDEBAR_OPEN);
export const setSidebarOpen = createAction(SET_SIDEBAR_OPEN);

export const clearHeaderTitle = createClearAction(CLEAR_HEADER_TITLE);
export const setHeaderTitle = createAction(SET_HEADER_TITLE);

export const clearConfirmMessage = createAction(CLEAR_CONFIRM_MESSAGE);
export const setConfirmMessage = createAction(SET_CONFIRM_MESSAGE);

export const clearHelpContent = createClearAction(CLEAR_HELP_CONTENT);
export const setHelpContent = createAction(SET_HELP_CONTENT);

export const clearSearchContent = createClearAction(CLEAR_SEARCH_CONTENT);
export const setSearchContent = createAction(SET_SEARCH_CONTENT);

export const clearOrderCart = createClearAction(CLEAR_ORDER_CART);
export const setOrderCart = createAction(SET_ORDER_CART);

export const setConfirmAction = createAction(SET_CONFIRM_ACTION);
export const setHotNotification = createAction(SET_HOT_NOTIFICATION);
export const setLocale = createAction(SET_LOCALE);
export const setPrintContent = createAction(SET_PRINT_CONTENT);
export const setScrollTop = createAction(SET_SCROLL_TOP);

export const setPagination = createAction(SET_PAGINATION);

export const clearFilterCategory = createClearAction(CLEAR_FILTER_CATEGORY);
export const setFilterCategory = createAction(SET_FILTER_CATEGORY);
